module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('h2', {
    staticClass: "h2",
    attrs: {
      "id": "cont"
    }
  }, [_c('a', {
    attrs: {
      "id": "page_vii"
    }
  }), _vm._v("TABLE OF CONTENTS")]), _vm._v(" "), _c('p', {
    staticClass: "toc"
  }, [_c('a', {
    attrs: {
      "href": "#/xhtml/Acknowledgements#ack"
    }
  }, [_c('strong', [_vm._v("Acknowledgements")])])]), _vm._v(" "), _c('p', {
    staticClass: "toc"
  }, [_c('a', {
    attrs: {
      "href": "#/xhtml/Introduction#int"
    }
  }, [_c('strong', [_vm._v("Introduction")])])]), _vm._v(" "), _c('p', {
    staticClass: "toc"
  }, [_c('a', {
    attrs: {
      "href": "#/xhtml/Introduction#mus"
    }
  }, [_c('em', [_vm._v("Music Never Ends")])])]), _vm._v(" "), _c('p', {
    staticClass: "toc"
  }, [_c('a', {
    attrs: {
      "href": "#/xhtml/Introduction#inf"
    }
  }, [_c('em', [_vm._v("Influencing the Decisions People Make")])])]), _vm._v(" "), _c('p', {
    staticClass: "toc"
  }, [_c('a', {
    attrs: {
      "href": "#/xhtml/Introduction#thr"
    }
  }, [_c('em', [_vm._v("Three Cultural Factors")])])]), _vm._v(" "), _c('p', {
    staticClass: "toc-chap"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/Chapter01#ch01",
      "title": "Link target outside of Sample"
    }
  }, [_c('strong', [_c('span', {
    staticClass: "toc-c"
  }, [_vm._v("Chapter 1")]), _vm._v(" The Mind and Three Imperatives")])])]), _vm._v(" "), _c('p', {
    staticClass: "toc1"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/Chapter01#lev1",
      "title": "Link target outside of Sample"
    }
  }, [_c('em', [_vm._v("Moving Deeper")])])]), _vm._v(" "), _c('p', {
    staticClass: "toc1"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/Chapter01#lev2",
      "title": "Link target outside of Sample"
    }
  }, [_c('em', [_vm._v("The BRAIN Initiative")])])]), _vm._v(" "), _c('p', {
    staticClass: "toc1"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/Chapter01#lev3",
      "title": "Link target outside of Sample"
    }
  }, [_c('em', [_vm._v("Three Imperatives")])])]), _vm._v(" "), _c('p', {
    staticClass: "toc-chap"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/Chapter02#ch02",
      "title": "Link target outside of Sample"
    }
  }, [_c('strong', [_c('span', {
    staticClass: "toc-c"
  }, [_vm._v("Chapter 2")]), _vm._v(" Mind Mysteries")])])]), _vm._v(" "), _c('p', {
    staticClass: "toc1"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/Chapter02#lev4",
      "title": "Link target outside of Sample"
    }
  }, [_c('em', [_vm._v("My Story of Feeling Alone")])])]), _vm._v(" "), _c('p', {
    staticClass: "toc1"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/Chapter02#lev5",
      "title": "Link target outside of Sample"
    }
  }, [_c('em', [_vm._v("Understanding the Emotional Control Panel")])])]), _vm._v(" "), _c('p', {
    staticClass: "toc1"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/Chapter02#lev6",
      "title": "Link target outside of Sample"
    }
  }, [_c('em', [_vm._v("Getting to 35% or 60% Sales Increases")])])]), _vm._v(" "), _c('p', {
    staticClass: "toc-chap"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/Chapter03#ch03",
      "title": "Link target outside of Sample"
    }
  }, [_c('strong', [_c('span', {
    staticClass: "toc-c"
  }, [_vm._v("Chapter 3")]), _vm._v(" The Seven Pathways")])])]), _vm._v(" "), _c('p', {
    staticClass: "toc1"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/Chapter03#lev7",
      "title": "Link target outside of Sample"
    }
  }, [_c('em', [_vm._v("1. Identify the Person")])])]), _vm._v(" "), _c('p', {
    staticClass: "toc1"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/Chapter03#lev8",
      "title": "Link target outside of Sample"
    }
  }, [_c('em', [_vm._v("2. Stimulate Emotion")])])]), _vm._v(" "), _c('p', {
    staticClass: "toc1"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/Chapter03#lev9",
      "title": "Link target outside of Sample"
    }
  }, [_c('em', [_vm._v("3. Calm the Mind")])])]), _vm._v(" "), _c('p', {
    staticClass: "toc1"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/Chapter03#lev10",
      "title": "Link target outside of Sample"
    }
  }, [_c('em', [_vm._v("4. Position / Reposition with a Unique Selling Proposition")])])]), _vm._v(" "), _c('p', {
    staticClass: "toc1"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/Chapter03#lev11",
      "title": "Link target outside of Sample"
    }
  }, [_c('em', [_vm._v("5. Tell a Story")])])]), _vm._v(" "), _c('p', {
    staticClass: "toc1"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/Chapter03#lev12",
      "title": "Link target outside of Sample"
    }
  }, [_c('em', [_vm._v("6. Interpret")])])]), _vm._v(" "), _c('p', {
    staticClass: "toc1"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/Chapter03#lev13",
      "title": "Link target outside of Sample"
    }
  }, [_c('em', [_vm._v("7. Permission to Act")])])]), _vm._v(" "), _c('p', {
    staticClass: "toc-chap"
  }, [_c('a', {
    attrs: {
      "id": "page_viii"
    }
  }), _c('span', {
    attrs: {
      "href": "#/xhtml/Chapter04#ch04",
      "title": "Link target outside of Sample"
    }
  }, [_c('strong', [_c('span', {
    staticClass: "toc-c"
  }, [_vm._v("Chapter 4")]), _vm._v(" #1 Identify the Persona")])])]), _vm._v(" "), _c('p', {
    staticClass: "toc1"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/Chapter04#lev14",
      "title": "Link target outside of Sample"
    }
  }, [_c('em', [_vm._v("What, How, and Why")])])]), _vm._v(" "), _c('p', {
    staticClass: "toc1"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/Chapter04#lev15",
      "title": "Link target outside of Sample"
    }
  }, [_c('em', [_vm._v("Falling Short of Expectations")])])]), _vm._v(" "), _c('p', {
    staticClass: "toc1"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/Chapter04#lev16",
      "title": "Link target outside of Sample"
    }
  }, [_c('em', [_vm._v("Theory of Emotion")])])]), _vm._v(" "), _c('p', {
    staticClass: "toc1"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/Chapter04#lev17",
      "title": "Link target outside of Sample"
    }
  }, [_c('em', [_vm._v("Creating a Persona")])])]), _vm._v(" "), _c('p', {
    staticClass: "toc1"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/Chapter04#lev18",
      "title": "Link target outside of Sample"
    }
  }, [_c('em', [_vm._v("Elements of a Persona")])])]), _vm._v(" "), _c('p', {
    staticClass: "toc1"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/Chapter04#lev19",
      "title": "Link target outside of Sample"
    }
  }, [_c('em', [_vm._v("Research")])])]), _vm._v(" "), _c('p', {
    staticClass: "toc1"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/Chapter04#lev20",
      "title": "Link target outside of Sample"
    }
  }, [_c('em', [_vm._v("Basic Characteristics")])])]), _vm._v(" "), _c('p', {
    staticClass: "toc1"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/Chapter04#lev21",
      "title": "Link target outside of Sample"
    }
  }, [_c('em', [_vm._v("Building Blocks to Create a Persona")])])]), _vm._v(" "), _c('p', {
    staticClass: "toc1"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/Chapter04#lev22",
      "title": "Link target outside of Sample"
    }
  }, [_c('em', [_vm._v("Deeper Inside Your Persona’s Thoughts")])])]), _vm._v(" "), _c('p', {
    staticClass: "toc1"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/Chapter04#lev23",
      "title": "Link target outside of Sample"
    }
  }, [_c('em', [_vm._v("12 Foundational Personas")])])]), _vm._v(" "), _c('p', {
    staticClass: "toc1"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/Chapter04#lev24",
      "title": "Link target outside of Sample"
    }
  }, [_c('em', [_vm._v("1. Trailblazers/Early Adopters")])])]), _vm._v(" "), _c('p', {
    staticClass: "toc1"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/Chapter04#lev25",
      "title": "Link target outside of Sample"
    }
  }, [_c('em', [_vm._v("2. My Brand/My Lifestyle/My Growth")])])]), _vm._v(" "), _c('p', {
    staticClass: "toc1"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/Chapter04#lev26",
      "title": "Link target outside of Sample"
    }
  }, [_c('em', [_vm._v("3. Money Matters")])])]), _vm._v(" "), _c('p', {
    staticClass: "toc1"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/Chapter04#lev27",
      "title": "Link target outside of Sample"
    }
  }, [_c('em', [_vm._v("4. On Financial Edge")])])]), _vm._v(" "), _c('p', {
    staticClass: "toc1"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/Chapter04#lev28",
      "title": "Link target outside of Sample"
    }
  }, [_c('em', [_vm._v("5. Right Thing to Do: Taking the High Road")])])]), _vm._v(" "), _c('p', {
    staticClass: "toc1"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/Chapter04#lev29",
      "title": "Link target outside of Sample"
    }
  }, [_c('em', [_vm._v("6. Love and Social Relationships")])])]), _vm._v(" "), _c('p', {
    staticClass: "toc1"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/Chapter04#lev30",
      "title": "Link target outside of Sample"
    }
  }, [_c('em', [_vm._v("7. Adrenaline Seekers: Opportunists")])])]), _vm._v(" "), _c('p', {
    staticClass: "toc1"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/Chapter04#lev31",
      "title": "Link target outside of Sample"
    }
  }, [_c('em', [_vm._v("8. Safe Players")])])]), _vm._v(" "), _c('p', {
    staticClass: "toc1"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/Chapter04#lev32",
      "title": "Link target outside of Sample"
    }
  }, [_c('em', [_vm._v("9. Hiding My Compulsion")])])]), _vm._v(" "), _c('p', {
    staticClass: "toc1"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/Chapter04#lev33",
      "title": "Link target outside of Sample"
    }
  }, [_c('em', [_vm._v("10. Fifty Plus")])])]), _vm._v(" "), _c('p', {
    staticClass: "toc1"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/Chapter04#lev34",
      "title": "Link target outside of Sample"
    }
  }, [_c('em', [_vm._v("11. Business 8 to 5")])])]), _vm._v(" "), _c('p', {
    staticClass: "toc1"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/Chapter04#lev35",
      "title": "Link target outside of Sample"
    }
  }, [_c('em', [_vm._v("12. Did I Matter?")])])]), _vm._v(" "), _c('p', {
    staticClass: "toc-chap"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/Chapter05#ch05",
      "title": "Link target outside of Sample"
    }
  }, [_c('strong', [_c('span', {
    staticClass: "toc-c"
  }, [_vm._v("Chapter 5")]), _vm._v(" Stimulate Emotion")])])]), _vm._v(" "), _c('p', {
    staticClass: "toc1"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/Chapter05#lev36",
      "title": "Link target outside of Sample"
    }
  }, [_c('em', [_vm._v("Eight Seconds to Pounce")])])]), _vm._v(" "), _c('p', {
    staticClass: "toc1"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/Chapter05#lev37",
      "title": "Link target outside of Sample"
    }
  }, [_c('em', [_vm._v("The Reticular Activating System")])])]), _vm._v(" "), _c('p', {
    staticClass: "toc1"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/Chapter05#lev38",
      "title": "Link target outside of Sample"
    }
  }, [_c('em', [_vm._v("The Spell of FOMO")])])]), _vm._v(" "), _c('p', {
    staticClass: "toc1"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/Chapter05#lev39",
      "title": "Link target outside of Sample"
    }
  }, [_c('em', [_vm._v("The Amygdala: Fight or Flight")])])]), _vm._v(" "), _c('p', {
    staticClass: "toc1"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/Chapter05#lev40",
      "title": "Link target outside of Sample"
    }
  }, [_c('em', [_vm._v("Conditioned to Fear")])])]), _vm._v(" "), _c('p', {
    staticClass: "toc1"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/Chapter05#lev41",
      "title": "Link target outside of Sample"
    }
  }, [_c('em', [_vm._v("Stimulating Emotion with Tasty Words and Language")])])]), _vm._v(" "), _c('p', {
    staticClass: "toc1"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/Chapter05#lev42",
      "title": "Link target outside of Sample"
    }
  }, [_c('em', [_vm._v("Stimulating the 12 Personas")])])]), _vm._v(" "), _c('p', {
    staticClass: "toc-chap"
  }, [_c('a', {
    attrs: {
      "id": "page_ix"
    }
  }), _c('span', {
    attrs: {
      "href": "#/xhtml/Chapter06#ch06",
      "title": "Link target outside of Sample"
    }
  }, [_c('strong', [_c('span', {
    staticClass: "toc-c"
  }, [_vm._v("Chapter 6")]), _vm._v(" Calm the Mind")])])]), _vm._v(" "), _c('p', {
    staticClass: "toc1"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/Chapter06#lev43",
      "title": "Link target outside of Sample"
    }
  }, [_c('em', [_vm._v("Unblock Decision Making")])])]), _vm._v(" "), _c('p', {
    staticClass: "toc1"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/Chapter06#lev44",
      "title": "Link target outside of Sample"
    }
  }, [_c('em', [_vm._v("Affirmations")])])]), _vm._v(" "), _c('p', {
    staticClass: "toc1"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/Chapter06#lev45",
      "title": "Link target outside of Sample"
    }
  }, [_c('em', [_vm._v("5 Appeals to Basic Human Primal Instincts")])])]), _vm._v(" "), _c('p', {
    staticClass: "toc1"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/Chapter06#lev46",
      "title": "Link target outside of Sample"
    }
  }, [_c('em', [_vm._v("A Cocktail of Brain Chemicals")])])]), _vm._v(" "), _c('p', {
    staticClass: "toc1"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/Chapter06#lev47",
      "title": "Link target outside of Sample"
    }
  }, [_c('em', [_vm._v("Calm the Mind with These Emotions")])])]), _vm._v(" "), _c('p', {
    staticClass: "toc1"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/Chapter06#lev48",
      "title": "Link target outside of Sample"
    }
  }, [_c('em', [_vm._v("7 Feelings that Add Warmth and Calm")])])]), _vm._v(" "), _c('p', {
    staticClass: "toc1"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/Chapter06#lev49",
      "title": "Link target outside of Sample"
    }
  }, [_c('em', [_vm._v("Colors that Stimulate and Calm")])])]), _vm._v(" "), _c('p', {
    staticClass: "toc1"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/Chapter06#lev50",
      "title": "Link target outside of Sample"
    }
  }, [_c('em', [_vm._v("Calming the 12 Personas")])])]), _vm._v(" "), _c('p', {
    staticClass: "toc-chap"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/Chapter07#ch07",
      "title": "Link target outside of Sample"
    }
  }, [_c('strong', [_c('span', {
    staticClass: "toc-c"
  }, [_vm._v("Chapter 7")]), _vm._v(" Position/Reposition")])])]), _vm._v(" "), _c('p', {
    staticClass: "toc1"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/Chapter07#lev51",
      "title": "Link target outside of Sample"
    }
  }, [_c('em', [_vm._v("Unique Selling Proposition and Brand Equity")])])]), _vm._v(" "), _c('p', {
    staticClass: "toc1"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/Chapter07#lev52",
      "title": "Link target outside of Sample"
    }
  }, [_c('em', [_vm._v("Your Brand Statement")])])]), _vm._v(" "), _c('p', {
    staticClass: "toc1"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/Chapter07#lev53",
      "title": "Link target outside of Sample"
    }
  }, [_c('em', [_vm._v("Positioning Based on Personality Types")])])]), _vm._v(" "), _c('p', {
    staticClass: "toc1"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/Chapter07#lev54",
      "title": "Link target outside of Sample"
    }
  }, [_c('em', [_vm._v("Proven Ways to Create a Blockbuster USP")])])]), _vm._v(" "), _c('p', {
    staticClass: "toc1"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/Chapter07#lev55",
      "title": "Link target outside of Sample"
    }
  }, [_c('em', [_vm._v("Using Gamification to Establish Positioning")])])]), _vm._v(" "), _c('p', {
    staticClass: "toc1"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/Chapter07#lev56",
      "title": "Link target outside of Sample"
    }
  }, [_c('em', [_vm._v("USP Ideas for the 12 Personas")])])]), _vm._v(" "), _c('p', {
    staticClass: "toc-chap"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/Chapter08#ch08",
      "title": "Link target outside of Sample"
    }
  }, [_c('strong', [_c('span', {
    staticClass: "toc-c"
  }, [_vm._v("Chapter 8")]), _vm._v(" Storytelling")])])]), _vm._v(" "), _c('p', {
    staticClass: "toc1"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/Chapter08#lev57",
      "title": "Link target outside of Sample"
    }
  }, [_c('em', [_vm._v("The Science Behind Why Storytelling Works")])])]), _vm._v(" "), _c('p', {
    staticClass: "toc1"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/Chapter08#lev58",
      "title": "Link target outside of Sample"
    }
  }, [_c('em', [_vm._v("The Eight Second Attention Span")])])]), _vm._v(" "), _c('p', {
    staticClass: "toc1"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/Chapter08#lev59",
      "title": "Link target outside of Sample"
    }
  }, [_c('em', [_vm._v("Three Stages of How the Brain Stores Information")])])]), _vm._v(" "), _c('p', {
    staticClass: "toc1"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/Chapter08#lev60",
      "title": "Link target outside of Sample"
    }
  }, [_c('em', [_vm._v("Ancient Storytelling Techniques")])])]), _vm._v(" "), _c('p', {
    staticClass: "toc1"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/Chapter08#lev61",
      "title": "Link target outside of Sample"
    }
  }, [_c('em', [_vm._v("Storytelling-in-Content Marketing Lessons Learned")])])]), _vm._v(" "), _c('p', {
    staticClass: "toc1"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/Chapter08#lev62",
      "title": "Link target outside of Sample"
    }
  }, [_c('em', [_vm._v("Using Story for the 12 Personas")])])]), _vm._v(" "), _c('p', {
    staticClass: "toc-chap"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/Chapter09#ch09",
      "title": "Link target outside of Sample"
    }
  }, [_c('strong', [_c('span', {
    staticClass: "toc-c"
  }, [_vm._v("Chapter 9")]), _vm._v(" Interpret")])])]), _vm._v(" "), _c('p', {
    staticClass: "toc1"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/Chapter09#lev63",
      "title": "Link target outside of Sample"
    }
  }, [_c('em', [_vm._v("Your Logical Sales Presentation")])])]), _vm._v(" "), _c('p', {
    staticClass: "toc1"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/Chapter09#lev64",
      "title": "Link target outside of Sample"
    }
  }, [_c('em', [_vm._v("Six Ways to Appeal to Logic")])])]), _vm._v(" "), _c('p', {
    staticClass: "toc1"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/Chapter09#lev65",
      "title": "Link target outside of Sample"
    }
  }, [_c('em', [_vm._v("Numeric Speed Bumps")])])]), _vm._v(" "), _c('p', {
    staticClass: "toc1"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/Chapter09#lev66",
      "title": "Link target outside of Sample"
    }
  }, [_c('em', [_vm._v("Reading-Level Appropriate Copy")])])]), _vm._v(" "), _c('p', {
    staticClass: "toc1"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/Chapter09#lev67",
      "title": "Link target outside of Sample"
    }
  }, [_c('em', [_vm._v("Interpreting for the 12 Personas")])])]), _vm._v(" "), _c('p', {
    staticClass: "toc-chap"
  }, [_c('a', {
    attrs: {
      "id": "page_x"
    }
  }), _c('span', {
    attrs: {
      "href": "#/xhtml/Chapter10#ch10",
      "title": "Link target outside of Sample"
    }
  }, [_c('strong', [_c('span', {
    staticClass: "toc-c"
  }, [_vm._v("Chapter 10")]), _vm._v(" Permission to Act")])])]), _vm._v(" "), _c('p', {
    staticClass: "toc1"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/Chapter10#lev68",
      "title": "Link target outside of Sample"
    }
  }, [_c('em', [_vm._v("Open the Door to Permission")])])]), _vm._v(" "), _c('p', {
    staticClass: "toc1"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/Chapter10#lev69",
      "title": "Link target outside of Sample"
    }
  }, [_c('em', [_vm._v("How to Neutralize Backfire")])])]), _vm._v(" "), _c('p', {
    staticClass: "toc1"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/Chapter10#lev70",
      "title": "Link target outside of Sample"
    }
  }, [_c('em', [_vm._v("Heading Off Gut Reaction That Can Prevail and Derail")])])]), _vm._v(" "), _c('p', {
    staticClass: "toc1"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/Chapter10#lev71",
      "title": "Link target outside of Sample"
    }
  }, [_c('em', [_vm._v("Principles of Persuasion")])])]), _vm._v(" "), _c('p', {
    staticClass: "toc1"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/Chapter10#lev72",
      "title": "Link target outside of Sample"
    }
  }, [_c('em', [_vm._v("Giving Permission to Act for the 12 Personas")])])]), _vm._v(" "), _c('p', {
    staticClass: "toc-chap"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/Chapter11#ch11",
      "title": "Link target outside of Sample"
    }
  }, [_c('strong', [_c('span', {
    staticClass: "toc-c"
  }, [_vm._v("Chapter 11")]), _vm._v(" Mind Pathway Comprehension by Channel")])])]), _vm._v(" "), _c('p', {
    staticClass: "toc1"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/Chapter11#lev73",
      "title": "Link target outside of Sample"
    }
  }, [_c('em', [_vm._v("Three Stages of Comprehension")])])]), _vm._v(" "), _c('p', {
    staticClass: "toc1"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/Chapter11#lev74",
      "title": "Link target outside of Sample"
    }
  }, [_c('em', [_vm._v("Comprehension by Channel")])])]), _vm._v(" "), _c('p', {
    staticClass: "toc1"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/Chapter11#lev75",
      "title": "Link target outside of Sample"
    }
  }, [_c('em', [_vm._v("o2o Channel Leaping")])])]), _vm._v(" "), _c('p', {
    staticClass: "toc-chap"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/Chapter12#ch12",
      "title": "Link target outside of Sample"
    }
  }, [_c('strong', [_c('span', {
    staticClass: "toc-c"
  }, [_vm._v("Chapter 12")]), _vm._v(" Coming Full Circle: Pathways as Strategy")])])]), _vm._v(" "), _c('p', {
    staticClass: "toc1"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/Chapter12#lev76",
      "title": "Link target outside of Sample"
    }
  }, [_c('em', [_vm._v("A New Template for Strategy")])])]), _vm._v(" "), _c('p', {
    staticClass: "toc1"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/Chapter12#lev77",
      "title": "Link target outside of Sample"
    }
  }, [_c('em', [_vm._v("The Big Picture of Each Persona")])])]), _vm._v(" "), _c('p', {
    staticClass: "toc-chap"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/Chapter13#ch13",
      "title": "Link target outside of Sample"
    }
  }, [_c('strong', [_c('span', {
    staticClass: "toc-c"
  }, [_vm._v("Chapter 13")]), _vm._v(" Persona #1: Trailblazers/Early Adopters")])])]), _vm._v(" "), _c('p', {
    staticClass: "toc1"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/Chapter13#lev78",
      "title": "Link target outside of Sample"
    }
  }, [_c('em', [_vm._v("1. Core Persona Values")])])]), _vm._v(" "), _c('p', {
    staticClass: "toc1"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/Chapter13#lev79",
      "title": "Link target outside of Sample"
    }
  }, [_c('em', [_vm._v("2. Stimulate Emotion")])])]), _vm._v(" "), _c('p', {
    staticClass: "toc1"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/Chapter13#lev80",
      "title": "Link target outside of Sample"
    }
  }, [_c('em', [_vm._v("3. Calm the Mind")])])]), _vm._v(" "), _c('p', {
    staticClass: "toc1"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/Chapter13#lev81",
      "title": "Link target outside of Sample"
    }
  }, [_c('em', [_vm._v("4. Position / Reposition")])])]), _vm._v(" "), _c('p', {
    staticClass: "toc1"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/Chapter13#lev82",
      "title": "Link target outside of Sample"
    }
  }, [_c('em', [_vm._v("5. Tell a Story")])])]), _vm._v(" "), _c('p', {
    staticClass: "toc1"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/Chapter13#lev83",
      "title": "Link target outside of Sample"
    }
  }, [_c('em', [_vm._v("6. Interpret")])])]), _vm._v(" "), _c('p', {
    staticClass: "toc1"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/Chapter13#lev84",
      "title": "Link target outside of Sample"
    }
  }, [_c('em', [_vm._v("7. Permission to Act")])])]), _vm._v(" "), _c('p', {
    staticClass: "toc-chap"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/Chapter14#ch14",
      "title": "Link target outside of Sample"
    }
  }, [_c('strong', [_c('span', {
    staticClass: "toc-c"
  }, [_vm._v("Chapter 14")]), _vm._v(" Persona #2: My Brand/My Lifestyle/My Growth")])])]), _vm._v(" "), _c('p', {
    staticClass: "toc1"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/Chapter14#lev85",
      "title": "Link target outside of Sample"
    }
  }, [_c('em', [_vm._v("1. Core Persona Values")])])]), _vm._v(" "), _c('p', {
    staticClass: "toc1"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/Chapter14#lev86",
      "title": "Link target outside of Sample"
    }
  }, [_c('em', [_vm._v("2. Stimulate Emotion")])])]), _vm._v(" "), _c('p', {
    staticClass: "toc1"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/Chapter14#lev87",
      "title": "Link target outside of Sample"
    }
  }, [_c('em', [_vm._v("3. Calm the Mind")])])]), _vm._v(" "), _c('p', {
    staticClass: "toc1"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/Chapter14#lev88",
      "title": "Link target outside of Sample"
    }
  }, [_c('em', [_vm._v("4. Position / Reposition")])])]), _vm._v(" "), _c('p', {
    staticClass: "toc1"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/Chapter14#lev89",
      "title": "Link target outside of Sample"
    }
  }, [_c('em', [_vm._v("5. Tell a Story")])])]), _vm._v(" "), _c('p', {
    staticClass: "toc1"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/Chapter14#lev90",
      "title": "Link target outside of Sample"
    }
  }, [_c('em', [_vm._v("6. Interpret")])])]), _vm._v(" "), _c('p', {
    staticClass: "toc1"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/Chapter14#lev91",
      "title": "Link target outside of Sample"
    }
  }, [_c('em', [_vm._v("7. Permission to Act")])])]), _vm._v(" "), _c('p', {
    staticClass: "toc-chap"
  }, [_c('a', {
    attrs: {
      "id": "page_xi"
    }
  }), _c('span', {
    attrs: {
      "href": "#/xhtml/Chapter15#ch15",
      "title": "Link target outside of Sample"
    }
  }, [_c('strong', [_c('span', {
    staticClass: "toc-c"
  }, [_vm._v("Chapter 15")]), _vm._v(" Persona #3: Money Matters")])])]), _vm._v(" "), _c('p', {
    staticClass: "toc1"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/Chapter15#lev92",
      "title": "Link target outside of Sample"
    }
  }, [_c('em', [_vm._v("1. Core Persona Values")])])]), _vm._v(" "), _c('p', {
    staticClass: "toc1"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/Chapter15#lev93",
      "title": "Link target outside of Sample"
    }
  }, [_c('em', [_vm._v("2. Stimulate Emotion")])])]), _vm._v(" "), _c('p', {
    staticClass: "toc1"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/Chapter15#lev94",
      "title": "Link target outside of Sample"
    }
  }, [_c('em', [_vm._v("3. Calm the Mind")])])]), _vm._v(" "), _c('p', {
    staticClass: "toc1"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/Chapter15#lev95",
      "title": "Link target outside of Sample"
    }
  }, [_c('em', [_vm._v("4. Position / Reposition")])])]), _vm._v(" "), _c('p', {
    staticClass: "toc1"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/Chapter15#lev96",
      "title": "Link target outside of Sample"
    }
  }, [_c('em', [_vm._v("5. Tell a Story")])])]), _vm._v(" "), _c('p', {
    staticClass: "toc1"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/Chapter15#lev97",
      "title": "Link target outside of Sample"
    }
  }, [_c('em', [_vm._v("6. Interpret")])])]), _vm._v(" "), _c('p', {
    staticClass: "toc1"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/Chapter15#lev98",
      "title": "Link target outside of Sample"
    }
  }, [_c('em', [_vm._v("7. Permission to Act")])])]), _vm._v(" "), _c('p', {
    staticClass: "toc-chap"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/Chapter16#ch16",
      "title": "Link target outside of Sample"
    }
  }, [_c('strong', [_c('span', {
    staticClass: "toc-c"
  }, [_vm._v("Chapter 16")]), _vm._v(" Persona #4: On Financial Edge")])])]), _vm._v(" "), _c('p', {
    staticClass: "toc1"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/Chapter16#lev99",
      "title": "Link target outside of Sample"
    }
  }, [_c('em', [_vm._v("1. Core Persona Values")])])]), _vm._v(" "), _c('p', {
    staticClass: "toc1"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/Chapter16#lev100",
      "title": "Link target outside of Sample"
    }
  }, [_c('em', [_vm._v("2. Stimulate Emotion")])])]), _vm._v(" "), _c('p', {
    staticClass: "toc1"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/Chapter16#lev101",
      "title": "Link target outside of Sample"
    }
  }, [_c('em', [_vm._v("3. Calm the Mind")])])]), _vm._v(" "), _c('p', {
    staticClass: "toc1"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/Chapter16#lev102",
      "title": "Link target outside of Sample"
    }
  }, [_c('em', [_vm._v("4. Position / Reposition")])])]), _vm._v(" "), _c('p', {
    staticClass: "toc1"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/Chapter16#lev103",
      "title": "Link target outside of Sample"
    }
  }, [_c('em', [_vm._v("5. Tell a Story")])])]), _vm._v(" "), _c('p', {
    staticClass: "toc1"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/Chapter16#lev104",
      "title": "Link target outside of Sample"
    }
  }, [_c('em', [_vm._v("6. Interpret")])])]), _vm._v(" "), _c('p', {
    staticClass: "toc1"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/Chapter16#lev105",
      "title": "Link target outside of Sample"
    }
  }, [_c('em', [_vm._v("7. Permission to Act")])])]), _vm._v(" "), _c('p', {
    staticClass: "toc-chap"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/Chapter17#ch17",
      "title": "Link target outside of Sample"
    }
  }, [_c('strong', [_c('span', {
    staticClass: "toc-c"
  }, [_vm._v("Chapter 17")]), _vm._v(" Persona #5: Right Thing to Do")])])]), _vm._v(" "), _c('p', {
    staticClass: "toc1"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/Chapter17#lev106",
      "title": "Link target outside of Sample"
    }
  }, [_c('em', [_vm._v("1. Core Persona Values")])])]), _vm._v(" "), _c('p', {
    staticClass: "toc1"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/Chapter17#lev107",
      "title": "Link target outside of Sample"
    }
  }, [_c('em', [_vm._v("2. Stimulate Emotion")])])]), _vm._v(" "), _c('p', {
    staticClass: "toc1"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/Chapter17#lev108",
      "title": "Link target outside of Sample"
    }
  }, [_c('em', [_vm._v("3. Calm the Mind")])])]), _vm._v(" "), _c('p', {
    staticClass: "toc1"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/Chapter17#lev109",
      "title": "Link target outside of Sample"
    }
  }, [_c('em', [_vm._v("4. Position / Reposition")])])]), _vm._v(" "), _c('p', {
    staticClass: "toc1"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/Chapter17#lev110",
      "title": "Link target outside of Sample"
    }
  }, [_c('em', [_vm._v("5. Tell a Story")])])]), _vm._v(" "), _c('p', {
    staticClass: "toc1"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/Chapter17#lev111",
      "title": "Link target outside of Sample"
    }
  }, [_c('em', [_vm._v("6. Interpret")])])]), _vm._v(" "), _c('p', {
    staticClass: "toc1"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/Chapter17#lev112",
      "title": "Link target outside of Sample"
    }
  }, [_c('em', [_vm._v("7. Permission to Act")])])]), _vm._v(" "), _c('p', {
    staticClass: "toc-chap"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/Chapter18#ch18",
      "title": "Link target outside of Sample"
    }
  }, [_c('strong', [_c('span', {
    staticClass: "toc-c"
  }, [_vm._v("Chapter 18")]), _vm._v(" Persona #6: Love and Social Relationships")])])]), _vm._v(" "), _c('p', {
    staticClass: "toc1"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/Chapter18#lev113",
      "title": "Link target outside of Sample"
    }
  }, [_c('em', [_vm._v("1. Core Persona Values")])])]), _vm._v(" "), _c('p', {
    staticClass: "toc1"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/Chapter18#lev114",
      "title": "Link target outside of Sample"
    }
  }, [_c('em', [_vm._v("2. Stimulate Emotion")])])]), _vm._v(" "), _c('p', {
    staticClass: "toc1"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/Chapter18#lev115",
      "title": "Link target outside of Sample"
    }
  }, [_c('em', [_vm._v("3. Calm the Mind")])])]), _vm._v(" "), _c('p', {
    staticClass: "toc1"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/Chapter18#lev116",
      "title": "Link target outside of Sample"
    }
  }, [_c('em', [_vm._v("4. Position / Reposition")])])]), _vm._v(" "), _c('p', {
    staticClass: "toc1"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/Chapter18#lev117",
      "title": "Link target outside of Sample"
    }
  }, [_c('em', [_vm._v("5. Tell a Story")])])]), _vm._v(" "), _c('p', {
    staticClass: "toc1"
  }, [_c('a', {
    attrs: {
      "id": "page_xii"
    }
  }), _c('span', {
    attrs: {
      "href": "#/xhtml/Chapter18#lev118",
      "title": "Link target outside of Sample"
    }
  }, [_c('em', [_vm._v("6. Interpret")])])]), _vm._v(" "), _c('p', {
    staticClass: "toc1"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/Chapter18#lev119",
      "title": "Link target outside of Sample"
    }
  }, [_c('em', [_vm._v("7. Permission to Act")])])]), _vm._v(" "), _c('p', {
    staticClass: "toc-chap"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/Chapter19#ch19",
      "title": "Link target outside of Sample"
    }
  }, [_c('strong', [_c('span', {
    staticClass: "toc-c"
  }, [_vm._v("Chapter 19")]), _vm._v(" Persona #7: Adrenaline Seekers: Opportunists")])])]), _vm._v(" "), _c('p', {
    staticClass: "toc1"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/Chapter19#lev120",
      "title": "Link target outside of Sample"
    }
  }, [_c('em', [_vm._v("1. Core Persona Values")])])]), _vm._v(" "), _c('p', {
    staticClass: "toc1"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/Chapter19#lev121",
      "title": "Link target outside of Sample"
    }
  }, [_c('em', [_vm._v("2. Stimulate Emotion")])])]), _vm._v(" "), _c('p', {
    staticClass: "toc1"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/Chapter19#lev122",
      "title": "Link target outside of Sample"
    }
  }, [_c('em', [_vm._v("3. Calm the Mind")])])]), _vm._v(" "), _c('p', {
    staticClass: "toc1"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/Chapter19#lev123",
      "title": "Link target outside of Sample"
    }
  }, [_c('em', [_vm._v("4. Position / Reposition")])])]), _vm._v(" "), _c('p', {
    staticClass: "toc1"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/Chapter19#lev124",
      "title": "Link target outside of Sample"
    }
  }, [_c('em', [_vm._v("5. Tell a Story")])])]), _vm._v(" "), _c('p', {
    staticClass: "toc1"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/Chapter19#lev125",
      "title": "Link target outside of Sample"
    }
  }, [_c('em', [_vm._v("6. Interpret")])])]), _vm._v(" "), _c('p', {
    staticClass: "toc1"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/Chapter19#lev126",
      "title": "Link target outside of Sample"
    }
  }, [_c('em', [_vm._v("7. Permission to Act")])])]), _vm._v(" "), _c('p', {
    staticClass: "toc-chap"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/Chapter20#ch20",
      "title": "Link target outside of Sample"
    }
  }, [_c('strong', [_c('span', {
    staticClass: "toc-c"
  }, [_vm._v("Chapter 20")]), _vm._v(" Persona #8: Safe Players")])])]), _vm._v(" "), _c('p', {
    staticClass: "toc1"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/Chapter20#lev127",
      "title": "Link target outside of Sample"
    }
  }, [_c('em', [_vm._v("1. Core Persona Values")])])]), _vm._v(" "), _c('p', {
    staticClass: "toc1"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/Chapter20#lev128",
      "title": "Link target outside of Sample"
    }
  }, [_c('em', [_vm._v("2. Stimulate Emotion")])])]), _vm._v(" "), _c('p', {
    staticClass: "toc1"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/Chapter20#lev129",
      "title": "Link target outside of Sample"
    }
  }, [_c('em', [_vm._v("3. Calm the Mind")])])]), _vm._v(" "), _c('p', {
    staticClass: "toc1"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/Chapter20#lev130",
      "title": "Link target outside of Sample"
    }
  }, [_c('em', [_vm._v("4. Position / Reposition")])])]), _vm._v(" "), _c('p', {
    staticClass: "toc1"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/Chapter20#lev131",
      "title": "Link target outside of Sample"
    }
  }, [_c('em', [_vm._v("5. Tell a Story")])])]), _vm._v(" "), _c('p', {
    staticClass: "toc1"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/Chapter20#lev132",
      "title": "Link target outside of Sample"
    }
  }, [_c('em', [_vm._v("6. Interpret")])])]), _vm._v(" "), _c('p', {
    staticClass: "toc1"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/Chapter20#lev133",
      "title": "Link target outside of Sample"
    }
  }, [_c('em', [_vm._v("7. Permission to Act")])])]), _vm._v(" "), _c('p', {
    staticClass: "toc-chap"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/Chapter21#ch21",
      "title": "Link target outside of Sample"
    }
  }, [_c('strong', [_c('span', {
    staticClass: "toc-c"
  }, [_vm._v("Chapter 21")]), _vm._v(" Persona #9: Hiding My Compulsion")])])]), _vm._v(" "), _c('p', {
    staticClass: "toc1"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/Chapter21#lev134",
      "title": "Link target outside of Sample"
    }
  }, [_c('em', [_vm._v("1. Core Persona Values")])])]), _vm._v(" "), _c('p', {
    staticClass: "toc1"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/Chapter21#lev135",
      "title": "Link target outside of Sample"
    }
  }, [_c('em', [_vm._v("2. Stimulate Emotion")])])]), _vm._v(" "), _c('p', {
    staticClass: "toc1"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/Chapter21#lev136",
      "title": "Link target outside of Sample"
    }
  }, [_c('em', [_vm._v("3. Calm the Mind")])])]), _vm._v(" "), _c('p', {
    staticClass: "toc1"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/Chapter21#lev137",
      "title": "Link target outside of Sample"
    }
  }, [_c('em', [_vm._v("4. Position / Reposition")])])]), _vm._v(" "), _c('p', {
    staticClass: "toc1"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/Chapter21#lev138",
      "title": "Link target outside of Sample"
    }
  }, [_c('em', [_vm._v("5. Tell a Story")])])]), _vm._v(" "), _c('p', {
    staticClass: "toc1"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/Chapter21#lev139",
      "title": "Link target outside of Sample"
    }
  }, [_c('em', [_vm._v("6. Interpret")])])]), _vm._v(" "), _c('p', {
    staticClass: "toc1"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/Chapter21#lev140",
      "title": "Link target outside of Sample"
    }
  }, [_c('em', [_vm._v("7. Permission to Act")])])]), _vm._v(" "), _c('p', {
    staticClass: "toc-chap"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/Chapter22#ch22",
      "title": "Link target outside of Sample"
    }
  }, [_c('strong', [_c('span', {
    staticClass: "toc-c"
  }, [_vm._v("Chapter 22")]), _vm._v(" Persona #10: Fifty Plus")])])]), _vm._v(" "), _c('p', {
    staticClass: "toc1"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/Chapter22#lev141",
      "title": "Link target outside of Sample"
    }
  }, [_c('em', [_vm._v("1. Core Persona Values")])])]), _vm._v(" "), _c('p', {
    staticClass: "toc1"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/Chapter22#lev142",
      "title": "Link target outside of Sample"
    }
  }, [_c('em', [_vm._v("2. Stimulate Emotion")])])]), _vm._v(" "), _c('p', {
    staticClass: "toc1"
  }, [_c('a', {
    attrs: {
      "id": "page_xiii"
    }
  }), _c('span', {
    attrs: {
      "href": "#/xhtml/Chapter22#lev143",
      "title": "Link target outside of Sample"
    }
  }, [_c('em', [_vm._v("3. Calm the Mind")])])]), _vm._v(" "), _c('p', {
    staticClass: "toc1"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/Chapter22#lev144",
      "title": "Link target outside of Sample"
    }
  }, [_c('em', [_vm._v("4. Position / Reposition")])])]), _vm._v(" "), _c('p', {
    staticClass: "toc1"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/Chapter22#lev145",
      "title": "Link target outside of Sample"
    }
  }, [_c('em', [_vm._v("5. Tell a Story")])])]), _vm._v(" "), _c('p', {
    staticClass: "toc1"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/Chapter22#lev146",
      "title": "Link target outside of Sample"
    }
  }, [_c('em', [_vm._v("6. Interpret")])])]), _vm._v(" "), _c('p', {
    staticClass: "toc1"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/Chapter22#lev147",
      "title": "Link target outside of Sample"
    }
  }, [_c('em', [_vm._v("7. Permission to Act")])])]), _vm._v(" "), _c('p', {
    staticClass: "toc-chap"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/Chapter23#ch23",
      "title": "Link target outside of Sample"
    }
  }, [_c('strong', [_c('span', {
    staticClass: "toc-c"
  }, [_vm._v("Chapter 23")]), _vm._v(" Persona #11: Business 8 to 5")])])]), _vm._v(" "), _c('p', {
    staticClass: "toc1"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/Chapter23#lev148",
      "title": "Link target outside of Sample"
    }
  }, [_c('em', [_vm._v("1. Core Persona Values")])])]), _vm._v(" "), _c('p', {
    staticClass: "toc1"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/Chapter23#lev149",
      "title": "Link target outside of Sample"
    }
  }, [_c('em', [_vm._v("2. Stimulate Emotion")])])]), _vm._v(" "), _c('p', {
    staticClass: "toc1"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/Chapter23#lev150",
      "title": "Link target outside of Sample"
    }
  }, [_c('em', [_vm._v("3. Calm the Mind")])])]), _vm._v(" "), _c('p', {
    staticClass: "toc1"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/Chapter23#lev151",
      "title": "Link target outside of Sample"
    }
  }, [_c('em', [_vm._v("4. Position / Reposition")])])]), _vm._v(" "), _c('p', {
    staticClass: "toc1"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/Chapter23#lev152",
      "title": "Link target outside of Sample"
    }
  }, [_c('em', [_vm._v("5. Tell a Story")])])]), _vm._v(" "), _c('p', {
    staticClass: "toc1"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/Chapter23#lev153",
      "title": "Link target outside of Sample"
    }
  }, [_c('em', [_vm._v("6. Interpret")])])]), _vm._v(" "), _c('p', {
    staticClass: "toc1"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/Chapter23#lev154",
      "title": "Link target outside of Sample"
    }
  }, [_c('em', [_vm._v("7. Permission to Act")])])]), _vm._v(" "), _c('p', {
    staticClass: "toc-chap"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/Chapter24#ch24",
      "title": "Link target outside of Sample"
    }
  }, [_c('strong', [_c('span', {
    staticClass: "toc-c"
  }, [_vm._v("Chapter 24")]), _vm._v(" Persona #12: Did I Matter?")])])]), _vm._v(" "), _c('p', {
    staticClass: "toc1"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/Chapter24#lev155",
      "title": "Link target outside of Sample"
    }
  }, [_c('em', [_vm._v("1. Core Persona Values")])])]), _vm._v(" "), _c('p', {
    staticClass: "toc1"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/Chapter24#lev156",
      "title": "Link target outside of Sample"
    }
  }, [_c('em', [_vm._v("2. Stimulate Emotion")])])]), _vm._v(" "), _c('p', {
    staticClass: "toc1"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/Chapter24#lev157",
      "title": "Link target outside of Sample"
    }
  }, [_c('em', [_vm._v("3. Calm the Mind")])])]), _vm._v(" "), _c('p', {
    staticClass: "toc1"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/Chapter24#lev158",
      "title": "Link target outside of Sample"
    }
  }, [_c('em', [_vm._v("4. Position / Reposition")])])]), _vm._v(" "), _c('p', {
    staticClass: "toc1"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/Chapter24#lev159",
      "title": "Link target outside of Sample"
    }
  }, [_c('em', [_vm._v("5. Tell a Story")])])]), _vm._v(" "), _c('p', {
    staticClass: "toc1"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/Chapter24#lev160",
      "title": "Link target outside of Sample"
    }
  }, [_c('em', [_vm._v("6. Interpret")])])]), _vm._v(" "), _c('p', {
    staticClass: "toc1"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/Chapter24#lev161",
      "title": "Link target outside of Sample"
    }
  }, [_c('em', [_vm._v("7. Permission to Act")])])]), _vm._v(" "), _c('p', {
    staticClass: "toct"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/About#abo",
      "title": "Link target outside of Sample"
    }
  }, [_c('strong', [_vm._v("About the Author")])])]), _vm._v(" "), _c('p', {
    staticClass: "toc"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/Notes#not",
      "title": "Link target outside of Sample"
    }
  }, [_c('strong', [_vm._v("End Notes")])])]), _vm._v(" "), _c('p', {
    staticClass: "toc"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/Resources#res",
      "title": "Link target outside of Sample"
    }
  }, [_c('strong', [_vm._v("CustomerMindCode.com Resources")])]), _c('a', {
    attrs: {
      "id": "page_xiv"
    }
  })])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-0df69bd0","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/xhtml/Contents.vue
// module id = 75
// module chunks = 0